<template>
  <Card :title="$t('common.undoListTitle')">
    <div class="UndoList">
      <div
        v-for="item in displayItems"
        :key="item.index"
        :class="[
          'UndoListItem',
          item.index === index && 'UndoListItem__selected',
          item.index > index && 'UndoListItem__fade'
        ]"
        @click="$emit('change', item.index)"
      >
        {{item.label}}
      </div>
    </div>
  </Card>
</template>

<script>
export default {
  inject: ['$t'],
  props: {
    index: {
      type: Number,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    displayItems() {
      return this.items.slice(0).reverse()
    }
  }
}
</script>

<style lang="scss">
.UndoList {
  padding: 8px 0;
}

.UndoListItem {
  padding: 8px 16px;
  cursor: pointer;
}

.UndoListItem__selected {
  background: #f5f5f5;
}

.UndoListItem__fade {
  opacity: 0.5;
}
</style>
